export const handleKnobPitchChangeInternal = (
  knobValue: number,
  knobValueWas: number,
  pitches: number[],
  diffsWere: number[],
  diffsAre: number[],
  dirty: boolean[]
) =>
  // undo the previous changes before applying the new ones
  pitches.map((pitch, i) =>
    dirty[i] ? pitch : (
      pitch +
      diffsWere[i] * (knobValueWas / 100) -
      diffsAre[i] * (knobValue / 100)
    )
  );
